module.exports = __webpack_public_path__ + "static/imv-logo-1b21f09ba494c4afefedf9722d20c405.png";